<template>
    <div>
        <h3 class="text-lg leading-6 font-medium text-gray-900">
            Last 30 days
        </h3>
        <div class="mt-5 grid grid-cols-1 rounded-lg bg-white overflow-hidden shadow md:grid-cols-2">
            <StatsCard v-for="(card, index) in stats" :title="card.title" :data="card.data" :index="index" :key="index"></StatsCard>
        </div>
    </div>
</template>

<script>
    import StatsCard from "@/Jobroll/StatsCard";
    export default {
        name: "IndexStats",
        components: {
            StatsCard
        },
        props: {
            stats: Array
        }
    }
</script>
